export const Marquee = ({ items }) => {
  const row = (key) => (
    <div key={key} className="flex items-center shrink-0">
      {items.map((it, i) => (
        <span key={i} className="flex items-center">
          <span className="mx-8 md:mx-14 font-serif italic font-light text-6xl md:text-8xl text-ink/[0.06] whitespace-nowrap">{it}</span>
          <span className="w-2 h-2 rotate-45 bg-ember/40 shrink-0" />
        </span>
      ))}
    </div>
  );
  return (
    <div className="overflow-hidden border-y border-ink/10 py-8 md:py-10 select-none bg-paper" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
};
